const ACTIONS = {
    TRIGGER_EDAP_EVENT: 'EDAP/TRIGGER_EDAP_EVENT',
    TRIGGER_EDAP_LISTING_BOOKNOW_CLICK: 'TRIGGER_EDAP_LISTING_BOOKNOW_CLICK',
    LOG_TEST_EXPOSURE: 'LOG_TEST_EXPOSURE'
};

const ACTION_CREATORS = {
    triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName,
                eventData,
                options
            }
        };
    },
    triggerEdapListingBooknowClick(actionLocation) {
        return {
            type: ACTIONS.TRIGGER_EDAP_LISTING_BOOKNOW_CLICK,
            payload: {
                actionLocation
            }
        };
    },
    logTestExposure(testName) {
        return {
            type: ACTIONS.LOG_TEST_EXPOSURE,
            payload: {
                testName
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
